import * as React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Favicon from 'react-favicon';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { appTheme } from '../themes/theme';
import SetPasswordInformation from '../components/SetPasswordInformation';
import useFetchGet from '../api/useFetchGet';

const icon = require('../assets/images/Q-logos_black.png');
const logo = require('../assets/images/logo.png');
const GoogleStore = require('../assets/images/google_playstore_app.png');
const AppleStore = require('../assets/images/apple_appstore_app.png');

function Copyright() {
  return (
    <Typography variant='body2' color='text.secondary' align='center'>
      Copyright ©
      <Link color='inherit' href='https://qashio.com/'>
        {' '}QASHIO{' '}
      </Link>
      {new Date().getFullYear()}
    </Typography>
  );
}

const steps = ['Set password'];

const theme = createTheme(appTheme);

export default function UserInformationPassword() {
  useEffect(() => {
    document.title = 'User Signup';
  });

  const { search } = useLocation();
  const token = new URLSearchParams(search).get('confirmation_token');
  const validToken = useFetchGet(`${process.env.REACT_APP_SERVER_HOSTNAME}/valid_token?token=${token}`);

  const [activeStep, setActiveStep] = React.useState(0);
  const [errors, setErrors] = React.useState(
    {
      password: '',
      confirm_password: '',
    },
  );

  const [userData, setUserData] = React.useState(
    {
      password: '',
      confirm_password: '',
      token,
    },
  );

  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return <SetPasswordInformation steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} errors={errors} setErrors={setErrors} userData={userData} setUserData={setUserData} />;
      default:
        throw new Error('Unknown step');
    }
  }

  const getComponent = () => {
    if (validToken.isPending === false) {
      if (validToken.data.error) {
        return (
          <Container component='main' maxWidth='sm' sx={{ mb: 4 }}>
            <Paper variant='outlined' sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
              <Typography component='h1' variant='h4' align='center'>
                {validToken.data.error}
              </Typography>
            </Paper>
            <Copyright />
          </Container>
        );
      }
      return (
        <Container component='main' maxWidth='sm' sx={{ mb: 4 }}>
          <Paper variant='outlined' sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
            <Typography component='h1' variant='h4' align='center'>
              User Password
            </Typography>
            <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            </Stepper>

            {activeStep === steps.length ? (
              <>
                <Typography variant='h4' gutterBottom align='center'>
                  Thank you for your submission.
                </Typography>
                <Typography variant='h6' gutterBottom align='center'>
                  Please download the mobile app from Google Play Store or App Store for login.
                </Typography>
                {process.env.REACT_APP_RAEGAN === 'UAE' ? (
                <Typography variant='h6' gutterBottom align='center'>
                    Please note you will need to scan your physical emirates ID card in order to get approved on the app.
                </Typography> ) : (<></>)}
                <Stack sx={{ width: '100%' }} alignItems='center'>
                  <div style={{ textAlign: 'center' }}>
                    <a href='https://play.google.com/store/apps/details?id=com.qashio.qashio'> <img src={GoogleStore} style={{ width: '40%', marginTop: '9px' }} alt='GoogleStore' /> </a>
                    <a href='https://apps.apple.com/us/app/qashio/id1609565376'> <img src={AppleStore} style={{ width: '40%', marginTop: '9px' }} alt='Apple Store' /> </a>
                  </div>
                </Stack>
              </>
            ) : (
              <> {getStepContent(activeStep)}</>
            )}

          </Paper>
          <Copyright />
        </Container>
      );
    }
    return null;
  };

  return (
    <>
      <Favicon url={icon}></Favicon>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppBar
          position='absolute'
          color='default'
          elevation={0}
          sx={{
            position: 'relative',
            borderBottom: (t) => `1px solid ${t.palette.divider}`,
          }}
        >
          <Toolbar>
            <Typography variant='h6' color='inherit' noWrap>
              <img src={logo} style={{ width: '50%', marginTop: '9px' }} alt='logo' />
            </Typography>
          </Toolbar>
        </AppBar>
        {getComponent()}
      </ThemeProvider>
    </>
  );
}
